module.exports = __webpack_public_path__ + "static/img/8.9ef7462d.png";